module.exports = __webpack_public_path__ + "media/src/assets/Images/sister-b4eb75f95f0a8422df384c320b253ea9.png";